import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const Ctx = createContext({ branding: null });

export function BrandingProvider({ children }) {
  const { user } = useAuth();
  const [branding, setBranding] = useState(null);

  useEffect(() => {
    if (!user || user === false) { setBranding(null); return; }
    api.get("/my/branding").then((r) => setBranding(r.data)).catch(() => setBranding(null));
  }, [user && user.id]);

  return <Ctx.Provider value={{ branding }}>{children}</Ctx.Provider>;
}

export const useBranding = () => useContext(Ctx);

export const themeStyle = (theme) =>
  theme
    ? {
        "--brand": theme.primary,
        "--brand-dark": theme.dark,
        "--brand-soft": theme.soft,
        "--brand-soft-dark": theme.soft_dark,
        "--brand-soft-border": theme.soft_border,
        "--brand-accent": theme.accent,
      }
    : {};
